<style lang="scss" scoped>
.groupBox {
  width: 200px;
  position: relative;
  height: 100%;
  flex-shrink: 0;
}
.group {
  border-right: 1px solid #dcdfe6;
  height: calc(100% - 60px);
  position: relative;
  overflow-y: auto;
  box-sizing: border-box;
  .item {
    font-size: 14px;
    cursor: pointer;
    padding: 15px 20px;
    &.active {
      color: #173bcf;
    }
    &:hover {
      background: #efefef;
    }
  }
}
.btn {
  position: absolute;
  width: 100%;
  color: #173bcf;
  left: 0;
  bottom: 20px;
  text-align: center;
  cursor: pointer;
}
.body {
  border-top: 1px solid #dcdfe6;
  height: 100%;
  background: #fff;
  display: flex;
}
.list {
  padding: 20px 40px;
  height: 100%;
  .item {
    float: left;
    width: 180px;
    position: relative;
    border: 1px solid #dcdfe6;
    margin-right: 15px;
    margin-bottom: 20px;

    cursor: pointer;
    .image {
      width: 100%;
      height: 165px;
      border-bottom: 1px solid #dcdfe6;
    }
    .text {
      width: 100%;
      padding: 0 6px;
      height: 36px;
      line-height: 36px;
      display: inline-block;
      box-sizing: border-box;
    }
    .checkbox {
      background: #fff;
      position: absolute;
      color: #fff;
      border: 1px solid #f0f0f0;
      z-index: 9;
      right: 0;
      width: 30px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      &.active {
        color: #17cfb8;
      }
    }
  }
}
.note {
  margin-right: 15px;
  font-size: 12px;
  color: #9b9b9b;
}
.iconmove,
.iconshanchu {
  font-size: 20px;
  vertical-align: -2px;
  margin-right: 10px;
}
.popMove {
  min-height: 130px;
  .name {
    width: calc(50% - 5px);
    float: left;
    padding: 5px;
    border: 1px solid transparent;
    box-sizing: border-box;
    margin-right: 10px;
    margin-bottom: 15px;
    border-radius: 4px;
    cursor: pointer;
    &:nth-child(even) {
      margin-right: 0;
    }
    &.active {
      border: 1px solid #173bcf;
    }
  }
}
.w {
  width: 80px;
  float: left;
}
</style>

<template>
  <div>
    <div class="body">
      <div class="groupBox">
        <div class="group">
          <div
            v-for="(item,index) in groups"
            :key="index"
            class="item"
            :class="{active:groupActive == item.folderId}"
            @click="selectGroup(item.folderId)"
          >
            <span class="w line1">{{item.name}}</span>
            <span>({{item.count || 0}})</span>
            <span class="fr" v-if="item.folderId != 0">
              <i class="el-icon-edit" @click.stop="editName(item)"></i>
              <i class="el-icon-delete ml10" @click.stop="delFolder(item.folderId)"></i>
            </span>
          </div>
        </div>
        <el-popover placement="top" width="160" v-model="pop">
          <div class="mb10">
            <el-input size="small" v-model="group" maxlength="16"></el-input>
          </div>
          <div class="alignr">
            <el-button size="mini" type="text" @click="pop = false">取消</el-button>
            <el-button type="primary" size="mini" @click="addGroup">确定</el-button>
          </div>
          <div class="btn" slot="reference">+ 新建分组</div>
        </el-popover>
      </div>
      <div class="list">
        <div class="clearfix mb20">
          <el-popover placement="bottom" width="220" v-model="popMove">
            <div class="popMove mb10 clearfix">
              <template v-for="(item,index) in groups">
                <div
                  class="name line1"
                  :key="index"
                  :class="{active:item.folderId == active.folderId}"
                  v-if="item.folderId !=groupActive"
                  @click="active = item"
                >{{item.name}}</div>
              </template>
            </div>
            <div class="alignr">
              <el-button size="mini" type="text" @click="popMove = false">取消</el-button>
              <el-button type="primary" size="mini" @click="move">确定</el-button>
            </div>
            <el-button
              :disabled="!movebtnDisabled"
              type="success"
              size="mini"
              slot="reference"
              class="mr10"
            >
              <i class="iconfont iconmove"></i>
              移动分组
            </el-button>
          </el-popover>
          <el-button type="success" size="mini" @click="del" :disabled="!movebtnDisabled">
            <i class="iconfont iconshanchu"></i>删除图片
          </el-button>
          <div class="fr">
            <span class="note">大小不超过5M</span>
            <el-upload
              :show-file-list="false"
              action
              style="display:inline-block"
              :before-upload="beforeFn"
              :http-request="uploadImage"
              accept="image/jpeg, image/png, image/bmp, image/gif"
            >
              <el-button type="primary" size="mini">本地上传</el-button>
            </el-upload>
          </div>
        </div>
        <div class="clearfix">
          <div
            class="item"
            @click="item.check = !item.check"
            v-for="(item,index) in list"
            :key="index"
          >
            <div class="checkbox" :class="{active:item.check}">
              <i class="iconfont icongou"></i>
            </div>
            <el-image :src="item.content.thumbUrl" lazy fit="contain" class="image"></el-image>
            <span class="text line1">{{item.content.title}}</span>
          </div>
        </div>
        <div class="alignc">
          <el-pagination
            :current-page.sync="page"
            :page-size="size"
            layout="total, prev, pager, next, jumper"
            :total="totalSize"
            @current-change="getItem"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/utils.js';

export default {
  components: {},
  computed: {},
  props: ['id'],
  watch: {
    list: {
      handler(val) {
        console.log(12);
        let ret = val.some(item => !!item.check);
        this.movebtnDisabled = ret;
      },
      deep: true,
    },
    group: {
      handler(val, oldval) {
        let iLen = utils.getStringLength(val);
        console.log(iLen);
        if (iLen > 16) {
          this.group = oldval;
        }
      },
    },
  },
  data() {
    return {
      group: '',
      groups: [],
      list: [],
      active: {},
      foldId: '',
      groupActive: '',
      pop: false,
      popMove: false,
      page: 1,
      size: 8,
      list: [],
      totalSize: 0,
      edit: false,
      movebtnDisabled: false,
    };
  },
  methods: {
    async uploadImage(file) {
      let fd = new FormData();
      fd.append('File', file.file);
      fd.append('Type', '2');
      let res = await this.$http.post(
        `/api/${this.id}/material/file/upload`,
        fd,
      );
      let res2 = await this.$http.post(`/api/${this.id}/material/image`, {
        title: res.name,
        thumburl: res.url,
        folderid: this.groupActive,
      });
      this.getItem();
      return;
    },
    beforeFn(file) {
      if (file.size > 5000 * 1024) {
        this.$message.error(`图片大小不能超过5mb`);
        return false;
      }
      return true;
    },
    editName(item) {
      this.pop = true;
      this.group = item.name;
      this.edit = true;
      this.foldId = item.folderId;
    },
    async getGroup() {
      let res = await this.$http(`/api/${this.id}/material/folders`, {
        params: {
          type: 2,
        },
      });
      this.groups = res;
      if (res.length) {
        this.groupActive = res[0].folderId;
      }
    },
    selectGroup(folderId) {
      this.groupActive = folderId;
      this.active = {};
      this.getItem();
    },
    async getItem() {
      let res = await this.$http(`/api/${this.id}/materials`, {
        params: {
          folderId: this.groupActive,
          type: 2,
          page: this.page,
          size: this.size,
        },
      });
      this.totalSize = res.totalSize;
      this.list = res.list.map(v => {
        v.check = false;
        return v;
      });
    },
    async addGroup() {
      if (!this.group) {
        this.$message.error('分组名称未填写');
        return false;
      }
      if (this.edit) {
        await this.$http.put(`/api/${this.id}/material/folder/${this.foldId}`, {
          name: this.group,
        });
      } else {
        let res = await this.$http.post(`/api/${this.id}/material/folder`, {
          name: this.group,
          type: 2,
        });
      }
      this.edit = false;
      this.pop = false;
      this.getGroup();
    },
    async del() {
      let res = await this.$confirm('确认删除这些图片?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      });
      if (res) {
        let arr = this.list.reduce((finalList, v) => {
          if (v.check) {
            finalList.push(v.materialId);
          }
          return finalList;
        }, []);
        if (arr.length) {
          await this.$http.delete(`/api/${this.id}/materials`, {
            data: { materialsId: arr },
          });
          this.getItem();
        } else {
          this.$message.error('未选择图片');
        }
      }
    },
    async move() {
      if (!this.active.folderId) {
        this.$message.error('请选择要移至的分组');
        return;
      }

      let arr = this.list.reduce((finalList, v) => {
        if (v.check) {
          finalList.push(v.materialId);
        }
        return finalList;
      }, []);
      if (arr.length) {
        await this.$http.put(`/api/${this.id}/materials/move`, {
          folderid: this.active.folderId,
          materialsId: arr,
        });
        await this.getGroup();
        await this.getItem();
      } else {
        this.$message.error('未选择图片');
      }
    },
    async delFolder(id) {
      let res = await this.$confirm(`确认删除此文件夹?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      });
      if (res) {
        let res = await this.$http.delete(
          `/api/${this.id}/material/folder/${id}`,
        );
        await this.getGroup();
        await this.getItem();
      }
    },
    async getData() {
      await this.getGroup();
      await this.getItem();
    },
  },
  async mounted() {
    this.getData();
  },
};
</script>
